module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "culture-and-environment.5d1df951.jpeg" + "?" + Date.now();